import React, { useState } from "react";
import {
  AiOutlineClose,
  AiOutlineMenu,
  AiOutlineSearch,
  AiFillTag,
} from "react-icons/ai";
import { BsFillCartFill, BsSaveFill } from "react-icons/bs";
import { TbTruckDelivery } from "react-icons/tb";
import { FaUserFriends, FaWallet } from "react-icons/fa";
import { MdFavorite, MdHelp } from "react-icons/md";

const Navbar = () => {
  const [nav, setNav] = useState(false);

  return (
    <div
      className="max-w-[1640px] mx-auto 
    flex justify-between items-center p-4"
    >
      <div className="flex items-center">
        <div onClick={() => setNav(!nav)} className="cursor-pointer">
          <AiOutlineMenu size={30} />
        </div>
        <h1 className="text-2xl lg:text-4xl px-2">
          Best <span className="font-bold text-orange-500">Eats</span>
        </h1>

        <div
          className="hidden lg:flex items-center
         bg-gray-200 rounded-full p-2 text-[14px]"
        >
          <h2
            className="bg-black text-white rounded-full
           p-2"
          >
            Delivery
          </h2>
          <h2 className="p-2">Pickup</h2>
        </div>
      </div>

      {/* Searc Input */}

      <div
        className="bg-gray-200 rounded-full flex items-center
        px-2 w-[150px] sm:w-[250px] md:w-[300px] lg:w-[500px]"
      >
        <AiOutlineSearch className="animate-ping opacity-75" size={25} />
        <input
          className="bg-transparent p-2 w-full 
            focus:outline-none"
          type="text"
          placeholder="Search foods"
        />
      </div>
      {/* Cart Button */}
      <button
        className="bg-orange-500 border-none text-white hidden md:flex
      items-center py-2 pr-4 rounded-full"
      >
        <BsFillCartFill size={20} className="mr-1" /> Cart
      </button>

      {/* Mobile Menu */}
      {/* Overlay */}

      {nav ? (
        <div
          className="bg-black/80 fixed w-full h-screen z-10 top-0
      left-0"
        ></div>
      ) : (
        ""
      )}
      {/* Side Drawer Menu */}
      <div
        className={
          nav
            ? "fixed top-0 left-0 w-[300px] h-screen bg-[#edededc5] z-10 duration-300"
            : "fixed top-0 left-[-100%] w-[300px] h-screen bg-white z-10 duration-300"
        }
      >
        <AiOutlineClose
          onClick={() => setNav(!nav)}
          size={30}
          className="absolute right-4 top-4 cursor-pointer duration-300"
        />
        <h2 className="text-2xl p-4">
          Best <span className="font-bold">Eats</span>
        </h2>
        <nav>
          <ul className="flex flex-col p-4 text-grey-700">
            <li className="text-xl py-4 flex">
              <TbTruckDelivery size={25} className="mr-4" /> Orders
            </li>
            <li className="text-xl py-4 flex">
              <MdFavorite size={25} className="mr-4" /> Favorites
            </li>
            <li className="text-xl py-4 flex">
              <FaWallet size={25} className="mr-4" /> Wallet
            </li>
            <li className="text-xl py-4 flex">
              <MdHelp size={25} className="mr-4" /> Help
            </li>
            <li className="text-xl py-4 flex">
              <AiFillTag size={25} className="mr-4" /> Promotions
            </li>
            <li className="text-xl py-4 flex">
              <BsSaveFill size={25} className="mr-4" /> Best Ones
            </li>
            <li className="text-xl py-4 flex">
              <FaUserFriends size={25} className="mr-4" /> Invite Friends
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
